import { BaseList, BaseDetail } from "App/Component/Bases";
import fields from "./fields";
import options from "./options";

const title = "Job Status Not Synceds";
const urlData = "jobStatusNotSynceds";

class List extends BaseList {
  constructor(props) {
    super(props)

    this.title = title;
    this.urlData = urlData;
    this.propsList = {
      exportImport: options.exportImportOptions,
    }
  }
}

class Detail extends BaseDetail {
  title = title;
  urlData = urlData;
  fields = fields;
}

export default { List, Detail };